<template>
  <span class="context-menu-icon" aria-hidden="true">
    <svg viewBox="0 0 20 20" fill="none">
      <path v-if="type === 'rename'" d="M4 14.8 4.5 12l7.8-7.8a1.4 1.4 0 0 1 2 0l1.5 1.5a1.4 1.4 0 0 1 0 2L8 15.5 5.2 16Z" />
      <path v-else-if="type === 'copy'" d="M7 6.5h7.5v9H7zM4.5 13.5h-1v-9h7.5v1" />
      <path v-else-if="type === 'move'" d="M4 6h9m-3-3 3 3-3 3M16 14H7m3 3-3-3 3-3" />
      <path v-else-if="type === 'section'" d="M4 4.5h12v4H4zM4 11.5h12v4H4z" />
      <path v-else-if="type === 'list'" d="M7 5h9M7 10h9M7 15h9M4 5h.01M4 10h.01M4 15h.01" />
      <path v-else-if="type === 'delete'" d="M4.5 6h11M8 3.5h4M6 6l.7 10h6.6L14 6M8.5 8.5v5M11.5 8.5v5" />
      <path v-else-if="type === 'leave'" d="M8 4H4.5v12H8M11.5 6.5 15 10l-3.5 3.5M15 10H8" />
      <path v-else-if="type === 'read'" d="M2.5 10s2.7-4.5 7.5-4.5 7.5 4.5 7.5 4.5-2.7 4.5-7.5 4.5S2.5 10 2.5 10ZM10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
      <path v-else-if="type === 'sort-name'" d="M4 5h8M4 10h6M4 15h4M14 7v8m-2-2 2 2 2-2" />
      <path v-else-if="type === 'sort-date'" d="M4 6.5h12v10H4zM4 9h12M7 3.5v3M13 3.5v3M7 12h2M11 12h2" />
      <path v-else-if="type === 'sort-priority'" d="M5 4v12M5 5h8l-1.7 2.5L13 10H5M16 13v4m-2-2 2 2 2-2" />
      <path v-else-if="type === 'reply'" d="m8 5-5 5 5 5v-3c4.2 0 6.8 1 9 3-1-5-4-7-9-7V5Z" />
      <path v-else-if="type === 'resend'" d="M15.5 7A6 6 0 1 0 16 12M15.5 3v4h-4" />
      <path v-else d="M4 10h12" />
    </svg>
  </span>
</template>

<script>
export default {
  name: "ContextMenuIcon",
  props: {
    type: { type: String, required: true },
  },
};
</script>
